// Generated by ReScript, PLEASE EDIT WITH CARE

import Classnames from "classnames";
import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as Theme__Responsive$PrezzeeRibbon from "../../../theme/Theme__Responsive.bs.js";

var circle = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.borderRadius(BsCssJs$PrezzeeRibbon.rem(100)),
      BsCssJs$PrezzeeRibbon.display("flex"),
      BsCssJs$PrezzeeRibbon.justifyContent("center"),
      BsCssJs$PrezzeeRibbon.alignItems("center"),
      BsCssJs$PrezzeeRibbon.boxSizing("borderBox")
    ]);

var circleSm = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.width(BsCssJs$PrezzeeRibbon.px(24)),
      BsCssJs$PrezzeeRibbon.height(BsCssJs$PrezzeeRibbon.px(24))
    ]);

var circleMd = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.width(BsCssJs$PrezzeeRibbon.rem(2.5)),
      BsCssJs$PrezzeeRibbon.height(BsCssJs$PrezzeeRibbon.rem(2.5)),
      BsCssJs$PrezzeeRibbon.padding(BsCssJs$PrezzeeRibbon.rem(0.5)),
      BsCssJs$PrezzeeRibbon.fontSize(BsCssJs$PrezzeeRibbon.rem(1)),
      BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.largeScreen, [
            BsCssJs$PrezzeeRibbon.width(BsCssJs$PrezzeeRibbon.rem(3.5)),
            BsCssJs$PrezzeeRibbon.height(BsCssJs$PrezzeeRibbon.rem(3.5)),
            BsCssJs$PrezzeeRibbon.padding(BsCssJs$PrezzeeRibbon.rem(0.25)),
            BsCssJs$PrezzeeRibbon.fontSize(BsCssJs$PrezzeeRibbon.rem(1.75))
          ]),
      BsCssJs$PrezzeeRibbon.selector("*", [
            BsCssJs$PrezzeeRibbon.maxWidth(BsCssJs$PrezzeeRibbon.pct(100)),
            BsCssJs$PrezzeeRibbon.maxHeight(BsCssJs$PrezzeeRibbon.pct(100)),
            BsCssJs$PrezzeeRibbon.width("auto"),
            BsCssJs$PrezzeeRibbon.height("auto")
          ])
    ]);

var Styles = {
  circle: circle,
  circleSm: circleSm,
  circleMd: circleMd
};

function CircleIcon(props) {
  var size = props.size;
  var className = props.className;
  var className$1 = className !== undefined ? className : "";
  var size$1 = size !== undefined ? size : /* Small */0;
  var circleClass = size$1 ? circleMd : circleSm;
  return JsxRuntime.jsx("div", {
              children: props.children,
              className: Classnames([
                    circle,
                    circleClass,
                    className$1
                  ])
            });
}

var make = CircleIcon;

export {
  Styles ,
  make ,
}
/* circle Not a pure module */
